import { Schema, defineTable } from 'squid';
export const invoiceTable = defineTable('invoice', {
    id: Schema.String,
    document_id: Schema.nullable(Schema.String),
    entity_id: Schema.nullable(Schema.String),
    status: Schema.String,
    balance_currency: Schema.nullable(Schema.String),
    balance_amount: Schema.nullable(Schema.Number),
    balance_scale: Schema.nullable(Schema.Number),
    line_items: Schema.JSON(Schema.Array(Schema.Any)),
    customer_contact_id: Schema.String,
    customer_name: Schema.nullable(Schema.String),
    customer_id: Schema.nullable(Schema.String),
    created_at: Schema.String,
    updated_at: Schema.String,
});
